import React, { useState } from 'react';
import {
  Drawer,
  DrawerProps,
  Button,
  Panel,
  ButtonToolbar,
  Stack
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import ImageIcon from '@rsuite/icons/Image';
import MediaIcon from '@rsuite/icons/Media';
import OthersIcon from '@rsuite/icons/Others';
import DrawerViewee from './DrawerViewee';

const DrawerViewe = (props: DrawerProps) => {

  const [showDrawer, setShowDrawer] = useState(false);

  const { onClose, ...rest } = props;
  return (
    <Drawer backdrop="static" size="xs" placement="right" onClose={onClose} {...rest}>
      <Drawer.Header>
        <Drawer.Actions>
          <Button onClick={onClose} appearance="ghost" color='cyan'>
            Previous
          </Button>
          <Button color="cyan" onClick={() => setShowDrawer(true)} appearance="primary">
            Next
          </Button>
        </Drawer.Actions>
      </Drawer.Header>
      <Drawer.Body>
        <Panel >
          <div style={{ marginBottom: '22px', marginLeft: '-7px' }}>
            <b> Select the number of products on slide</b>
          </div>
          <ButtonToolbar>
            <Stack direction='column' spacing={10} alignItems='flex-start'>
              <Button color="cyan" appearance="subtle" onDoubleClick={() => setShowDrawer(true)}>
                <Stack direction='column' alignItems='flex-start'>
                  <Stack spacing={10}><Icon as={ImageIcon} /><b>One product per slide</b></Stack>
                  <p>You can select the number of images</p>
                </Stack>
              </Button>
              <Button color="cyan" appearance="subtle" onDoubleClick={() => setShowDrawer(true)}>
                <Stack direction='column' alignItems='flex-start'>
                  <Stack spacing={10}><Icon as={MediaIcon} /><b>Multiple product on slide</b></Stack>
                  <p>You can select the number of images</p>
                </Stack>
              </Button>
              <Button color="cyan" appearance="subtle" onDoubleClick={() => setShowDrawer(true)}>
                <Stack direction='column' alignItems='flex-start'>
                  <Stack spacing={10}><Icon as={OthersIcon} /><b>Looking for a buyer template</b></Stack>
                  <p>You can select the number of images</p>
                </Stack>
              </Button>
            </Stack>
          </ButtonToolbar>
        </Panel>
        <Panel >
          <div style={{ marginBottom: '22px', marginLeft: '-7px' }}>
            <b> Selected option</b>
          </div>
          <ButtonToolbar>
            <Stack direction='column' spacing={10} alignItems='flex-start'>
              <Button color="cyan" appearance="subtle" onDoubleClick={() => setShowDrawer(true)}>
                <Stack direction='column' alignItems='flex-start'>
                  <Stack spacing={10}><Icon as={ImageIcon} /><b>Default template selected</b></Stack>
                  <p>You can select the number of images</p>
                </Stack>
              </Button>
            </Stack>
          </ButtonToolbar>
        </Panel>
      </Drawer.Body>
      <DrawerViewee open={showDrawer} onClose={() => setShowDrawer(false)} />
    </Drawer>
  );
};

export default DrawerViewe;